export const getEnvironment = () => import.meta.env.MODE;

export const isDevelopment =
  import.meta.env.DEV || import.meta.env.VITE_CI === "true";

export const isDevelopmentWithMulesoftMocks =
  import.meta.env.MODE === "development" &&
  import.meta.env.VITE_USE_MULESOFT_MOCKS === "true" &&
  import.meta.env.VITE_E2E !== "true"; // Remove mocks when running e2e tests

export const isStaging = () =>
  getEnvironment() === "staging" || getEnvironment() === "staging-deployment";

export const isProduction = () =>
  getEnvironment() === "production" ||
  getEnvironment() === "production-deployment";

export const isNotProduction = () =>
  !isProduction() || import.meta.env.VITE_CI === "true";
